var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11.402,
    viewBox: "0 0 16 11.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "296560_invite_share_envelope_send_letter_icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91654",
    d: "m158.234 183.929-4.5-4.885 4.509-4.517a.148.148 0 0 1 .253.1v9.2a.148.148 0 0 1-.262.102zm-6.88-2.505a1.379 1.379 0 0 1-.976.4h-.012a1.406 1.406 0 0 1-.993-.411l-1.335-1.333-4.582 4.665a.148.148 0 0 0 .106.252h13.914a.148.148 0 0 0 .109-.248l-4.585-4.97zm-.987-.632a.368.368 0 0 0 .262-.109l6.821-6.832a.148.148 0 0 0-.1-.253h-13.984a.148.148 0 0 0-.1.253l6.844 6.833a.367.367 0 0 0 .256.108zm-7.875-5.888v8.986a.148.148 0 0 0 .254.1l4.56-4.642-4.561-4.553a.148.148 0 0 0-.254.105z",
    style: {
      fill: "#30c48d"
    },
    transform: "translate(-142.491 -173.599)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeGreen);
export default __webpack_public_path__ + "static/media/envelope-green.svg";
export { ForwardRef as ReactComponent };